import { IconButton } from '@material-ui/core'
import axios from 'axios';
import React, { useState, useEffect } from 'react';
import styled from 'styled-components'



const FeaturedContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const FeaturedItem = styled.div`
  flex: 1;
  background: linear-gradient(120deg, rgba(176, 136, 249, 0.9), rgba(218, 159, 249, 1));
  padding: 20px 10px;
  margin: 10px;
  color: #fff;
  border-radius: 10px;
  position: relative;
  overflow: hidden;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;

  @media (max-width: 768px) {
    flex-basis: 100%;
    margin: 10px 0;
  }
`;

const FeaturedTitle = styled.div`
  font-size: 23px;
  padding: 5px;
  font-weight: 600;
`;

const FeaturedTotal = styled.div`
  font-size: 18px;
  font-weight: 500;
  padding: 5px;
`;

const FeaturedYear = styled.div`
  font-size: 18px;
  font-weight: 500;
  padding: 5px;
`;

const Icon = styled.img`
  position: absolute;

  @media (max-width: 768px) {
    display: none;
  }
`;

const IconButtonStyled = styled.div`
  width: 80px;
  height: 80px;
  background: #fff;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 2.5rem;
  right: 2rem;

  @media (max-width: 768px) {
    display: none;
  }
`;

const FeatureItemWrapper = styled.div``;

// const Bubble = styled.div`
//   height: 130px;
//   width: 130px;
//   background: #c47aff;
//   border-radius: 50%;
//   position: absolute;
//   top: 0;
//   right: -1rem;
//   overflow: hidden;

//   @media (max-width: 768px) {
//     display: none;
//   }
// `;

// const BubbleSecond = styled.div`
//   height: 200px;
//   width: 200px;
//   background: rgba(176, 136, 249, 0.9);
//   border-radius: 50%;
//   position: absolute;
//   top: 3rem;
//   right: -4rem;
//   overflow: hidden;

//   @media (max-width: 768px) {
//     display: none;
//   }
// `;

const Featured = () => {
  const currentYear = new Date().getFullYear();
  const [featuredData, setFeaturedData] = useState([])
  const GetTotalUserCount = async () => {
    axios({
      method: "get",
      url: "http://localhost:82/Bmu_backend/hodapproveddashboard.php",
      config: { headers: { "Content-Type": "application/json, text/plain, */*" } },
    })
      .then((response) => {
        const data = response.data
        console.log('data', data)
        setFeaturedData(
          [
            {
              id: "1",
              title: "Totals no of Case",
              total: data[1],
              icon: "/images/result declared.png",
            },
            {
              id: "2",
              title: "Total no of Case Pending",
              total: data[0],
              icon: "/images/result remaining.png",
            },
            {
              id: "3",
              title: "Total no of Case win",
              total: data[3],
              icon: "/images/teacher.png",
            }
          ])


      })
      .catch((error) => {
        console.log('error', error)
      })
  }
  useEffect(() => {
    GetTotalUserCount()
  }, [])

  console.log("featuredData", featuredData)
  return (
    <>
      <FeaturedContainer>
        {featuredData &&
          featuredData.map((item, index) => (
            <FeaturedItem key={index}>
              <FeatureItemWrapper>
                <FeaturedTitle>{item.title} </FeaturedTitle>
                <FeaturedTotal>Total: {item.total} </FeaturedTotal>
                <FeaturedYear>Year :{currentYear} </FeaturedYear>
              </FeatureItemWrapper>

           
             
              <IconButtonStyled>
                <Icon src={item.icon} alt="icons" />
              </IconButtonStyled>
            </FeaturedItem>
          ))}
      </FeaturedContainer>

    </>
  );

}


export default Featured